import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useDeactivatePatient() {
  const [isDeactivating, setDeactivating] = useState(false);

  const deactivate = useCallback((patientId) => {
    setDeactivating(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    return quarkusApi
      .put(`/patients/${patientId}/deactivate`, null, authHeader)
      .finally(() => setDeactivating(false));
  }, []);

  return { deactivate, isDeactivating };
}
